import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./Layout.css";

export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  const [navVisible, setNavVisible] = useState(!isHome);

  useEffect(() => {
    if (!isHome) {
      setNavVisible(true);
      return;
    }
    setNavVisible(false);

    const el = document.querySelector("[data-hero]");
    if (!el) return;

    // يظهر النافبار بعد تجاوز الهيرو
    const obs = new IntersectionObserver(
      ([entry]) => setNavVisible(!entry.isIntersecting),
      { threshold: 0.12 }
    );

    obs.observe(el);
    
    return () => obs.disconnect();
  }, [isHome]);

  return (
    <div className="layout">
      <Navbar visible={navVisible} />
      <main className="layout__main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
